import { Environment, ProductName } from '@sb/library/base';

export const BrandEnvironment = new Environment({
    Application: {
        ProductName: ProductName.Test443,
        ProductionMode: true,
        WebsiteBase: '/',
        Hostname: 'test443.com',
        BaseHref: undefined,
        BaseUrls: {
            Api: '//api.test443.com/v1/',
            App: 'https://app.test443.com',
        },
        LanguagesSupported: ['en'],
    },
    Help: {
        VirtualHelperURL: 'https://support.mymusicstaff.com/en/articles/1378/',
        ExternalCalendarFeedsHelpURL: 'https://support.mymusicstaff.com/articles/1491/',
        Elevio: {
            Active: true,
            ElevioID: "589c86136bdbd",
            Hidden: [18],
            Disabled: [],
            ArticleIDs: {
                WebsiteBuilder: {
                    Upload: 1423,
                    Hostname: 202,
                    ScriptCode: 188,
                    NoTeachersVisible: 1482
                },
                EmailSettings: {
                    SPF: 1017,
                    DKIM: 1019
                },
                Reminders: {
                    Email: 1032,
                    SMS: 1031
                },
                ProfilePictureUpload: {
                    ForTeacher: 1431,
                    ForStudent: 994
                },
                BusinessLogoUpload: 1434,
                AddPolicyAgreement: {
                    ToSignupForm: 1404,
                    ToContactForm: 1432
                },
                GoogleReviews: 1554
            }
        }
    },
    Telemetry: {
        GoogleAnalytics: {
            ID: 'G-4NGN4E2PV0'
        },
        Clarity: {
            ProjectID: "rtbhrb66jq"
        },
        Intercom: {
            AppID: "yvf2p27u"
        },
        reCAPTCHA: {
            SiteKey: "6LeTTjEUAAAAAJG1Dpg41l_MmQzYgbtn93FwRy-8"
        }
    },
    Payment: {
        Stripe: {
            PublicKey: "pk_test_laE0EY7pZb4VQVp1L96X9dyI",
            TeacherPaymentMethodConfigurationKey: "pmc_1NlCVHAdlU23LDcY5IIJZPeX",
            DefaultPaymentMethodConfigurationKey: "pmc_1NTR56AdlU23LDcY2jnKOWOe"
        },
        PayPalCommercePlatform: {
            //Changing this? There is a corresponding value in the backend web/app config
            ClientID: "AfSG2W79yvE2EfrW3aSvG-7m3_P4wftJK0MHaQl7hwh-9lRyRZf-oA6mlIBqadeH2CAbBUIygsJZ7782",
            BNCode: "Port443CPFS_Ecom"
        }
    }
});

export const BrandStagingURLOverrides = {};
export const BrandRestoreURLOverrides = {};
export const BrandTestURLOverrides = {};
export const BrandProductName = ProductName.Test443;
